module.exports = __webpack_public_path__ + "static/media/arst.a64d1147.svg";